module.exports = __webpack_public_path__ + "media/open.d1cef37a.mp3";